const iosTimeFit = (time = '') => {
  return new Date(time.replace(/-/g, '/')).getTime();
};

export const findComponentsEnum = (pluginItem, id = '') => {
  let components = [];
  let comEnum = {
    SINGLE_IMAGE: { type: 'SingleColImg', col: 1 }, // 单列图
    DOUBLE_IMAGE: { type: 'DoubleColImg', col: 2 }, // 双列图
    SIDESLIP_IMAGE: { type: 'LateSlidingColImg', col: null }, // 横划图
    TAKE_TURNS_IMAGE: { type: 'Swiper', col: null }, // 轮播图
    SINGLE_GOODS: { type: 'GoodsList', col: 1 }, // 单列商品
    SINGLE_GOODS_LEFTRIGHT: { type: 'GoodsList', col: 1, rowNum: 111 }, // 左右单列商品
    DOUBLE_GOODS: { type: 'GoodsList', col: 2 }, // 双列商品
    SINGLE_COUPON: { type: 'Coupon', col: 1 }, // 单列优惠券
    DOUBLE_COUPON: { type: 'Coupon', col: 2 }, // 双列优惠券
    SIDESLIP_COUPON: { type: 'Coupon', col: 3 }, // 多列优惠券
    RIGHT_SIDE_RULE: { type: 'RuleModal', col: null }, //规则弹窗
    SINGLE_REDEEM: { type: 'Redeem', col: null }, // 兑换码
    SINGLE_TITLE: { type: 'TitleBlock', col: null }, // 标题栏
    SINGLE_SPLIT_LINE: { type: 'SplitLine', col: null }, // 分割线
    SINGLE_RICH_TEXT: { type: 'RichText', col: null }, // 富文本
    SINGLE_STU_VERIFY: { type: 'StudentCheck', col: null }, //支付宝学生验证
    SINGLE_MEMBERSHIP_CARD: { type: 'memberShip', col: null }, //会员卡
    SINGLE_CURRENCY: { type: 'ExchangeRecord', col: null }, // 积分
    LIST_SHOP: { type: 'Shop', col: null },
    FALL_SHOP: { type: 'Shop', col: null },
    SINGLE_VOTE: { type: 'VoteList', col: null }, // 竞猜
    SINGLE_LIVE: { type: 'LIVE', col: null }, // 竞猜
    SINGLE_MATCH: { type: 'MATCH', col: null }, // 赛事组件
    SINGLE_GAME_TASK: { type: 'TaskList', col: null }, // 赛事组件
    SINGLE_FORM: { type: 'FORM', col: null }, // 赛事组件
    SINGLE_SCORE_LOTTERY: { type: 'SCORE_LOTTERY', col: null }, // 抽奖
    SINGLE_RANKING: { type: 'RANKING', col: null }, // 排行榜
  };

  pluginItem &&
    pluginItem.forEach((element) => {
      console.log('element.style', element, element.style);
      let componentKey = `${
        Number(element.rowNum) === 111
          ? `${element.style}_${element.type}_LEFTRIGHT`
          : `${element.style}_${element.type}`
      }`;
      for (let i in comEnum) {
        if (i === componentKey) {
          console.log('componentKey', componentKey);
          const { type, col } = comEnum[i];
          if (type.includes('Img') || type.includes('Swiper')) {
            comEnum[i]['infoItem'] =
              element.pluginImages &&
              element.pluginImages.map((item, index) => ({
                linkUrl: item.href,
                imgUrl: item.image,
                index,
              }));
          }
          if (type.includes('GoodsList')) {
            comEnum[i]['infoItem'] =
              element.pluginGoods &&
              element.pluginGoods.map((item) => ({
                imgUrl: item.goodsPicture,
                scribePrice: item.goodsLinePrice,
                price: item.goodsPrice,
                title: item.goodsName,
                goodsId: item.goodsId,
                showSale: item.showSale,
                currency: item.currency,
                djPoint: item.djPoint,
                timePoint: item.timePoint,
                sellLimitTimeDto: item.sellLimitTimeDto || {},
                limitType: item.limitType,
                type: item.type,
              }));
          }
          if (type.includes('Coupon')) {
            comEnum[i]['infoItem'] =
              element.pluginCoupons &&
              element.pluginCoupons.map((item) => ({
                imgUrl: item.couponPicture,
                ruleNum: Number(item.couponCode),
                pluginId: item.pluginId,
                uuid: element.uuid,
              }));
          }
          if (type.includes('RuleModal')) {
            comEnum[i]['infoItem'] =
              element.pluginRules &&
              element.pluginRules.map((item) => ({
                title: item.title,
                imgUrl: item.imgUrl,
                contentType: item.contentType,
                contentText: item.contentText,
              }));
          }
          if (type.includes('Redeem')) {
            comEnum[i]['infoItem'] = element.pluginRedeems;
          }
          if (type.includes('TitleBlock')) {
            comEnum[i]['infoItem'] = element.pluginTitles;
          }
          if (type.includes('SplitLine')) {
            comEnum[i]['infoItem'] = element.pluginSplitLines;
          }
          if (type.includes('RichText')) {
            comEnum[i]['infoItem'] = element.pluginRichTexts;
          }
          if (type.includes('StudentCheck')) {
            comEnum[i]['infoItem'] = element.pluginStuVerifys;
          }
          if (type.includes('memberShip')) {
            comEnum[i]['infoItem'] = element.pluginMembershipCards;
          }
          if (type.includes('ExchangeRecord')) {
            comEnum[i]['infoItem'] = element.pluginCurrencys;
          }
          if (type.includes('Shop')) {
            comEnum[i]['infoItem'] = element.pluginStoreConfigs;
          }
          if (type.includes('LIVE')) {
            comEnum[i]['infoItem'] = element.pluginLiveConfigDtos[0];
          }
          if (type.includes('VoteList')) {
            const arr = element.voteOptionResList;

            const getIsReward = (
              voteRule = '',
              voted,
              voteResult,
              voteOptionDtoList,
              voteInNum,
              voteType,
              votedNoReward = false,
            ) => {
              if (voteType === 'pop' && voted && !votedNoReward) {
                return true;
              }
              if (voteRule === 'single' && voted && voteResult === 'win' && !votedNoReward) {
                return true;
              }
              if (voteRule === 'multiple') {
                const filterArr = voteOptionDtoList.filter((item) => {
                  return item.voteResult === 'win' && item.voted;
                });
                if (voted && filterArr.length >= voteInNum && !votedNoReward) {
                  return true;
                }
              }
              return false;
            };

            const getiIsDisabled = (isShowTime, dtoItem, item, voteRule, voteInNum) => {
              if (isShowTime) {
                return true;
              }
              if (dtoItem.voted && dtoItem.votedNoReward) {
                return true;
              }
              if (!dtoItem.voted && new Date().getTime() > iosTimeFit(item.voteEndTime)) {
                return true;
              }
              if (dtoItem.voted && new Date().getTime() < iosTimeFit(item.voteEndTime)) {
                return true;
              }

              if (
                dtoItem.voted &&
                item.announceTime &&
                new Date().getTime() > iosTimeFit(item.announceTime)
              ) {
                if (voteRule === 'multiple') {
                  const filterArr = item.voteOptionDtoList.filter((filterItem) => {
                    return filterItem.voteResult === 'win' && filterItem.voted;
                  });
                  if (filterArr.length === voteInNum) {
                    return true;
                  }
                  if (!dtoItem.voteResult) {
                    return true;
                  }
                  if (dtoItem.voteResult && filterArr.length !== voteInNum) {
                    return true;
                  }
                }
                if (voteRule === 'single') {
                  if (dtoItem.voteResult !== 'win') {
                    return '猜错了';
                  }
                }
              }
              return false;
            };

            const getDisabledText = (isShowTime, dtoItem, item, voteRule, voteInNum) => {
              if (isShowTime) {
                return '未开始';
              }
              if (dtoItem.voted && dtoItem.votedNoReward) {
                return '感谢参与';
              }
              if (
                new Date().getTime() > iosTimeFit(item.voteEndTime) &&
                (!item.announceTime ||
                  (item.announceTime && new Date().getTime() < iosTimeFit(item.announceTime)))
              ) {
                return '即将公布';
              }
              if (
                !dtoItem.voted &&
                item.announceTime &&
                new Date().getTime() > iosTimeFit(item.announceTime)
              ) {
                return '已结束';
              }
              if (!dtoItem.voted && new Date().getTime() > iosTimeFit(item.voteEndTime)) {
                return '已结束';
              }
              if (dtoItem.voted && new Date().getTime() < iosTimeFit(item.voteEndTime)) {
                return '已投票';
              }

              if (
                dtoItem.voted &&
                item.announceTime &&
                new Date().getTime() > iosTimeFit(item.announceTime)
              ) {
                if (voteRule === 'multiple') {
                  const filterArr = item.voteOptionDtoList.filter((filterItem) => {
                    return filterItem.voteResult === 'win' && filterItem.voted;
                  });
                  if (filterArr.length === 0) {
                    return '猜错了';
                  }
                  if (filterArr.length < voteInNum) {
                    return `未全选对(${filterArr.length}/${voteInNum})`;
                  }
                }
                if (voteRule === 'single') {
                  if (dtoItem.voteResult !== 'win') {
                    return '猜错了';
                  }
                }
              }
              if (
                dtoItem.voted &&
                item.announceTime &&
                new Date().getTime() > iosTimeFit(item.announceTime) &&
                voteRule === 'multiple' &&
                !dtoItem.voteResult
              ) {
                return '猜错了';
              }
              return '';
            };

            const getIsLightDisabled = (dtoItem, item) => {
              if (dtoItem.voted && dtoItem.votedNoReward) {
                return false;
              }
              if (dtoItem.voted && new Date().getTime() < iosTimeFit(item.voteEndTime)) {
                return true;
              }
              if (
                dtoItem.voted &&
                item.announceTime &&
                new Date().getTime() > iosTimeFit(item.voteEndTime) &&
                new Date().getTime() < iosTimeFit(item.announceTime)
              ) {
                return true;
              }
              if (
                dtoItem.voted &&
                ((item.announceTime && new Date().getTime() < iosTimeFit(item.announceTime)) ||
                  !item.announceTime)
              ) {
                return true;
              }
              if (
                new Date().getTime() > iosTimeFit(item.voteEndTime) &&
                (!item.announceTime ||
                  (item.announceTime && new Date().getTime() < iosTimeFit(item.announceTime)))
              ) {
                return true;
              }

              return false;
            };
            console.log('arr', arr);
            arr.forEach((item, index) => {
              console.log(item);
              const isShowTime = new Date().getTime() < iosTimeFit(item.voteStartTime);
              item.voteOptionDtoList.forEach((dtoItem, dtoIndex) => {
                dtoItem.isShowTime = isShowTime;
                dtoItem.voteStartTime = item.voteStartTime;
                dtoItem.isReward = getIsReward(
                  element.pluginVoteActConfigs[index]?.voteRule,
                  dtoItem.voted,
                  dtoItem.voteResult,
                  item.voteOptionDtoList,
                  Number(element.pluginVoteActConfigs[index]?.voteInNum),
                  element.pluginVoteActConfigs[index]?.voteType,
                  dtoItem.votedNoReward,
                );
                dtoItem.isDisabled = getiIsDisabled(
                  isShowTime,
                  dtoItem,
                  item,
                  element.pluginVoteActConfigs[index]?.voteRule,
                  Number(element.pluginVoteActConfigs[index]?.voteInNum),
                );
                dtoItem.isLightDisabled = getIsLightDisabled(dtoItem, item);
                dtoItem.disabledText = getDisabledText(
                  isShowTime,
                  dtoItem,
                  item,
                  element.pluginVoteActConfigs[index]?.voteRule,
                  Number(element.pluginVoteActConfigs[index]?.voteInNum),
                );
                dtoItem.allVoteNums = item.allVoteNums || 0;
                dtoItem.noLogin = !!(
                  !window.ygpBridge &&
                  !id &&
                  new Date().getTime() > iosTimeFit(item.voteEndTime)
                );
              });
              arr[index].optionList = JSON.stringify(item.voteOptionDtoList);
              arr[index].votePicUrl = element.pluginVoteActConfigs[index]?.votePicUrl;
              arr[index].activityName = element.pluginVoteActConfigs[index]?.activityName;
            });

            comEnum[i]['infoItem'] = {
              list: arr,
              ...element.voteStyleConfigDto,
              noLogin: !!(!window.ygpBridge && !id),
            };
          }
          /* 赛事组件 */
          if (type.includes('MATCH')) {
            comEnum[i]['infoItem'] = element.pluginMatchDtos;
          }
          if (type.includes('TaskList')) {
            comEnum[i]['infoItem'] = element.pluginGameTaskDtos;
          }
          if (type.includes('FORM')) {
            comEnum[i]['infoItem'] = element.pluginFormConfigs;
          }
          if (type.includes('SCORE_LOTTERY')) {
            comEnum[i]['infoItem'] = element.pluginScoreLotterys;
          }

          if (type.includes('RANKING')) {
            comEnum[i]['infoItem'] = element.pluginRankings;
          }
          components.push({
            id: element.id,
            type,
            col,
            infoItem: comEnum[i]['infoItem'],
            rowNum: element.rowNum || null,
            showType: element.style,
            imgDisplayType: element.imgDisplayType || 'fill',
          });
        }
      }
    });
  return { components };
};
export const trackParams = {
  track_code: 600000000000,
  page_name: '乐高微页面',
};
export const findObjValue = (obj, key) => {
  let val = null;
  for (let i in obj) {
    if (key == i) {
      val = obj[i];
    }
  }
  return val;
};
export const findTrackPageComment = (type) => {
  const commentEnum = {
    SingleColImg: '乐高微页面-点击图片（单列图）组件',
    Swiper: '乐高微页面-点击图片（轮播图）组件',
    DoubleColImg: '乐高微页面-点击图片（双列图）组件',
    LateSlidingColImg: '乐高微页面-点击图片（横滑图）组件',
    GoodsList: '乐高微页面-点击商品',
    Coupon: '乐高微页面-点击优惠券',
    TaskList: '乐高微页面-点击游戏任务',
  };
  let val = null;
  for (let i in commentEnum) {
    if (type == i) {
      val = commentEnum[i];
    }
  }
  return val;
};
export const findPaySource = (env) => {
  let source = null;
  switch (env) {
    case 'ali_mini':
      source = 'ALIMINI';
      break;
    case 'wx_mini':
      source = 'JSAPI';
      break;
    case 'android':
      source = 'ANDROID';
      break;
    case 'ios':
      source = 'IOS';
      break;
    default:
      source = 'ANDROID';
  }
  return source;
};
export const findMemberShipSource = (env) => {
  let source = null;
  switch (env) {
    case 'ali_mini':
      source = 'MINI_PROGRAM';
      break;
    case 'wx_mini':
      source = 'MINI_PROGRAM';
      break;
    case 'android':
      source = 'APP';
      break;
    case 'ios':
      source = 'APP';
      break;
    default:
      source = 'APP';
  }
  return source;
};

export const findFormSource = (env) => {
  let source = null;
  switch (env) {
    case 'ali_mini':
      source = 'MA_ALIPAY';
      break;
    case 'wx_mini':
      source = 'MA_WECHAT';
      break;
    case 'android':
      source = 'APP_ANDROID';
      break;
    case 'ios':
      source = 'APP_IOS';
      break;
    case 'harmony':
      source = 'APP_HARMONY';
      break;
    case 'h5':
      source = 'H5';
      break;
    default:
      source = 'H5';
  }
  return source;
};
